import Vue from 'vue';
import VueRouter from 'vue-router';
import store from "../store";
import {BUSY, CLEAR} from "@/store/mutation-types";
import {routes} from "./routes"
import {i18n} from "@/locales";

Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    window.scrollTo(0,0);
  }
});

router.beforeResolve((to, from, next) => {
  if (routeHandler.isOpen(to)) {
    routeHandler.setTitle(to)
    next();
  } else {
    if (!routeHandler.handleTokenAuthentication(to, next)) {
      routeHandler.handleAuthorization(from, to, next);
    }
  }
});

router.beforeEach((to, from, next) => {
  if (
    store.getters.showSettings === false &&
    to.fullPath.startsWith('/settings')
  ) {
    next({name: 'my-leads'});
  } else {
    next();
  }
});

const routeHandler = {
  isOpen: function(route) {
    return route.matched.some(record => record.meta.open)
  },
  handleTokenAuthentication: function(to, callback) {
    if (to.query.t && to.query.s) {
      store.commit(BUSY, true);
      store.dispatch('clearAll').then(() => {
        store.dispatch('tokenAuth', {token: to.query.t, selector: to.query.s}).then(() => {
          if(store.state.USER_STATE === false){
            this.logOut(callback)
          } else {
            this.allow(callback, to)
          }
        });
      })
      return true;
    }
    return false;
  },
  handleAuthorization: function(from, to, callback) {
    if (!this.sameRoute(from, to, callback)) {
      this.authorizeUser(callback, to);
    }
  },
  sameRoute: function(from, to, callback) {
    if (from.name === to.name) {
      callback();
      return true;
    }
    return false;
  },
  authorizeUser: function(callback, to) {
    store.commit(BUSY, true);
    store.dispatch('checkState').then(() => {
      if(store.state.USER_STATE === false) {
        this.logOut(callback, to);
      } else {
        this.allow(callback, to);
      }
    });
  },
  logOut: function(callback, to) {
    store.commit(CLEAR);
    store.commit(BUSY, false);
    callback({name: "log-in", query:{to:to.fullPath}});
  },
  allow: function(callback, to) {
    store.dispatch('updateGlobals').then(() => {
      store.commit(BUSY, false);
      this.setTitle(to)
      callback();
    });
  },
  getTitle: function getTitle (to) {
    const title = to.meta.title;
    if (title) {
      return typeof title === 'function' ? title.call(Vue) : title;
    } else {
      return 'Installer Dashboard';
    }
  },
  setTitle: function(to) {
    const title = this.getTitle(to);
    if (title) {
      document.title = i18n.t('browserTitle', { pageTitle: i18n.t(title) });
    }
  }
}

export default router
